import type { BackDropTokens } from './types';

export const backDrop: BackDropTokens = {
  colors: {
    background: 'rgba(0,0,0,0.8)',
  },
};
